import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';

import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AzureCosmosDbV2Sink } from 'app/model/pipeline/copysink/azure-cosmos-db.v2.copysink';
import { writeBehaviorOptionValues } from 'app/shared/constants/write-behavior.const';
import { CopySinkAdapter } from 'app/model/adapters/activities/copysink/copysink.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureCosmosDbV2Sink),
    asynchronous: true,
    adapts: {
        type: '*',
        writeBatchTimeout: '*',
        writeBatchSize: '*',
        writeBehavior: '*',
        maxConcurrentConnections: '*',
        disableMetricsCollection: '*'
    }
})
export class AzureCosmosDbV2SinkAdapter extends CopySinkAdapter<AzureCosmosDbV2Sink, Model.CosmosDbSqlApiSink> {
    protected override async _toResource(model: AzureCosmosDbV2Sink): Promise<Model.CosmosDbSqlApiSink> {
        const result: Model.CosmosDbSqlApiSink = {
            type: AzureCosmosDbV2Sink.MODEL.name
        };
        const writeBatchTimeout = ValueAdapter.toResource(model, AzureCosmosDbV2Sink.WRITE_BATCH_TIMEOUT);
        if (writeBatchTimeout != null && writeBatchTimeout !== '') {
            // don't need pass '' to backend
            result.writeBatchTimeout = writeBatchTimeout;
        }
        result.writeBatchSize = ValueAdapter.toResource(model, AzureCosmosDbV2Sink.WRITE_BATCH_SIZE);
        result.writeBehavior = ValueAdapter.toResource(model, AzureCosmosDbV2Sink.WRITE_BEHAVIOR);
        result.disableMetricsCollection = ValueAdapter.toResource(
            model,
            AzureCosmosDbV2Sink.DISABLE_METRICS_COLLECTION
        );
        CopySinkAdapter.maxConcurrentConnectionsToResource(model, result);
        CopySinkAdapter.toCommonCopySinkResource(model, result, this.context);
        return result;
    }

    protected override async _toModel(resource: Model.CosmosDbSqlApiSink, owner: Activity): Promise<AzureCosmosDbV2Sink> {
        const result = Owned.create<AzureCosmosDbV2Sink>(Metamodel.modelFor(AzureCosmosDbV2Sink), owner);
        ValueAdapter.toModel(result, AzureCosmosDbV2Sink.WRITE_BATCH_TIMEOUT, resource.writeBatchTimeout);
        ValueAdapter.toModel(result, AzureCosmosDbV2Sink.WRITE_BATCH_SIZE, resource.writeBatchSize);
        ValueAdapter.toModel(result, AzureCosmosDbV2Sink.DISABLE_METRICS_COLLECTION, resource.disableMetricsCollection);

        // handle upper case and lower case
        let writeBehavior = resource.writeBehavior;
        if (writeBehavior && typeof writeBehavior === 'string') {
            const lowerCaseValue = writeBehavior.toLowerCase();
            switch (lowerCaseValue) {
                case writeBehaviorOptionValues.insert:
                    writeBehavior = writeBehaviorOptionValues.insert;
                    break;
                case writeBehaviorOptionValues.upsert:
                    writeBehavior = writeBehaviorOptionValues.upsert;
                    break;
                default:
                    break;
            }
        }
        ValueAdapter.toModel(result, AzureCosmosDbV2Sink.WRITE_BEHAVIOR, writeBehavior);

        CopySinkAdapter.maxConcurrentConnectionsToModel(resource, result);
        CopySinkAdapter.toCommonCopySinkModel(result, resource);

        return result;
    }
}
